import React, { forwardRef } from "react";
import styled from "@emotion/styled";
import { colors, fontSize } from "style";

const StyledActionButton = styled.button`
  height: 4rem;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: ${fontSize.small};
  font-weight: 600;
  padding: 0.9rem 0.8rem 0.9rem 0.9rem !important;
  color: ${colors.purpleRainBase};
  background: ${colors.white};
  border-radius: 0.6rem;
  border: none;
  cursor: pointer;
  transition: all 0.2s;
  text-decoration: none;

  &:hover:not(:disabled) {
    box-shadow: 0 1px 6px 0 rgba(85, 76, 197, 0.16);
  }

  &:focus {
    box-shadow: 0 1px 6px 0 rgba(85, 76, 197, 0.16);
  }

  &:disabled {
    color: ${colors.grayAnatomyLight2};
    box-shadow: none;
  }

  &:after {
    display: none;
  }
`;

/**
 * ActionButton
 *
 * An action rather than a submit, so it can sit inside a form without sending it.
 */
const ActionButton = forwardRef((props, ref) => <StyledActionButton type="button" ref={ref} {...props} />);

ActionButton.displayName = "ActionButton";

export default ActionButton;
